import GET_AUTHORIZATION from '@features/authorization/graphql/queries/getAuthorization';
import { useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { setSimulateUserShortcutModal } from '@/slices/modals';
import { useDispatch } from '@/store';

/**
 * INSTANCIARLO UNA SOLA VEZ (en `GlobalComponents`). Registra los shortcuts de teclado
 * globales de la app. El listener solo se registra si el usuario tiene el permiso
 * `shortcutsEnabled` (`Access.GlobalShortcuts` — hoy solo AmaruGod); sin permiso no hay
 * ningún handler enganchado a `window`.
 *
 * Shortcuts:
 * - `Ctrl/Cmd + Alt + S` → abre el modal de simulación rápida de usuario.
 */
const useGlobalShortcuts = () => {
  const dispatch = useDispatch();
  // Query no-suspense: `GET_AUTHORIZATION` ya está en caché (la traen los AuthorizationWrapper),
  // así que esto resuelve desde caché sin suspender el árbol global.
  const { data } = useQuery(GET_AUTHORIZATION);
  const shortcutsEnabled = data?.authorization.authorizationGeneral.shortcutsEnabled ?? false;

  useEffect(() => {
    if (!shortcutsEnabled) return;

    const onKeyDown = (event: KeyboardEvent) => {
      // `event.key` con Alt puede venir como carácter alterno según el layout — usar `code`.
      if (event.code === 'KeyS' && event.altKey && (event.ctrlKey || event.metaKey)) {
        event.preventDefault();
        dispatch(setSimulateUserShortcutModal({ open: true }));
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [shortcutsEnabled, dispatch]);
};

export default useGlobalShortcuts;
